
import template from './new_account_confirmation.html';

//Instantiate Page Variables 
var NewAccountConfPageViewModel = function(page)
{
	var self = this;
	self.page = page;
}

//Handle interaction with page 
var NewAccountConfPage = function(bindings) {
	var self = this;
	this.self = self;
	this.bindings = bindings;
	this.viewModel = new NewAccountConfPageViewModel(this);
	this.name = 'NewAccountConfPage';

	//Event (Post/After): Load once
	this.init = function() {
		document.title = 'New Account Confirmation';
	};

	//Event (Post/After): Refresh page data
	this.updateData = function() {

	};

	//Event (Pre/Before): Remove 
	this.teardown = function() {
	};

};

//Assign Page(HTML/JS) to Grape
export default {
	route: '[/]new_account_confirmation',
	page_class: NewAccountConfPage,
	template: template
}
